import { slice } from './slice';

export const {
	setRawRendering,
	setAiRendering,
	setCanonical,
	setSignature,
	clearDirty,
	initFromMetadata,
	resetRendering
} = slice.actions;

export const {
	selectAiChanged,
	selectAiRendering,
	selectCanonical,
	selectRawChanged,
	selectRawRendering,
	selectRenderingDirty,
	selectSignature
} = slice.selectors;

export type { RenderingSource, State as RenderingState } from './state.type';
